import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { deletePointsServer, getPointsServer } from "../../../apis/pointsApis";
import { Table } from "antd";
import getPointsColumns from "../../../const/columns/pointsColumns";

const Coins = () => {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = async () => {
    try {
      const res = await getPointsServer();
      setPoints(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deletePoints = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Reward?"
    );
    if (isConfirmed) {
      const res = await deletePointsServer(id);
      setLoading(true);
      fetchRewards();
    }
  };
  const columns = getPointsColumns(deletePoints);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link to="/addPoints" className="btn add-new btn-primary mb-3">
                Add Points
              </Link>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={points?.length > 0 ? points : []}
                  className="table-striped "
                  rowKey={(record) => record.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Coins;
